/**
 * Web replacement for react-native-localization: same dot-notation API and setLanguage/getLanguage.
 * Supported codes: en, fr, Du (Dutch), pt — must match keys below.
 */
function createWebLocalizedStrings(table, defaultKey = 'en') {
  const keys = new Set(Object.keys(table));
  const fallback = table[defaultKey] || {};
  let lang = defaultKey;

  return new Proxy(
    {
      setLanguage(code) {
        lang = keys.has(code) ? code : defaultKey;
      },
      getLanguage() {
        return lang;
      },
    },
    {
      get(target, prop, receiver) {
        if (prop in target || typeof prop === 'symbol') {
          return Reflect.get(target, prop, receiver);
        }
        const t = table[lang] || fallback;
        if (Object.prototype.hasOwnProperty.call(t, prop)) return t[prop];
        return fallback[prop];
      },
    }
  );
}

const translations = {
  "en": {
    // Member Edit screen (info_details.js)
    listings: "Listings",
    connections: "Connections",
    portfolio: "Portfolio",
    uploadNewProfilePicture: "Upload new profile picture",
    uploadNewCompanyPicture: "Upload new company logo",
    personalInformation: "Personal Information",
    companyInformation: "Company Information",
    male: "Male",
    female: "Female",
    other: "Other",
    fName: "First Name",
    lName: "Last Name",
    familyName: "Family Name",
    country: "Country",
    state: "State",
    city: "City",
    zipCode: "Zip Code",
    street: "Street",
    number: "Number",
    contactInformation: "Contact Information",
    email: "E-mail",
    cellPhone: "Cell Phone",
    shortIntro: "Short Introduction ",
    language: "Language",
    chooseLanguage: "Choose Language",
    changeEmail: "Change Email",
    changePassword: "Change Password",
    closeEditMode: "Close Edit Mode",
    logout: "Logout?",
    hey: "Hey",
    doYouWantToSaveYourInformation: "Save Changes?",   //given as 'Save Changes?'
    companyName: "Company Name",
    title: "Title - Function *",
    licence: "Licence Number - Certification(s)",
    spokenLanguage: "Spoken Language(s)",
    agentCode: "Agent Code",
    appointmentLink: "Calendly Link (Optional)",
    whoami: "About *",
    home: "Home",
    news: "News",
    feed: "Feed",
    listingLayout: "Listing Layout",
    profile: "Profile",
    //home.js
    members: "MEMBERS",
    portfolio: "PORTFOLIO",
    // Information Pop up
    contactUs: "Contact us",
    cancel: "Cancel",
    ok: "OK",
    yes: "Yes",
    no: "No",
    sendEmail: "Send email",
    // members.js
    myconnection: "My Connections",
    connectionrequest: "Requests",
    memberspool: "MEMBERS",

    // Connection requests
    requestReceived: "Request Received",
    requestSent: "Request Sent",
    //portfolio.js
    portfoliofeeds: "Portfolio Feeds",
    portfolionews: "24h PORTFOLIO NEWS",
    listings_portfolio: "Listings - Portfolio",
    //portfolio_feed.js
    receivedactivefeeds: "Received Feeds",
    availablelistings: "New Listings",
    sharedactivefeeds: "Sent Feeds",
    //listing_portfolio.js
    mylistings: "My Listings",
    myportfolio: "My Portfolio",
    portfoliopool: "Portfolio",
    // Portfolio Pool Filters
    filterName: "Filter Name",
    inactive: "Inactive",
    public: "Public",
    pocket: "Pocket",
    //-----------------------------------------------------------------

    // //login1.js
    welcome: "Welcome",
    login: "Login",
    signup: "Sign Up",
    descLine1: "This app will connect you with other Real-Estate",
    descLine2: "professionals and help you create your own",
    descLine3: "Multiple-Listing System",
    //welcomeBack.js
    welcomeback: "Welcome Back!",
    enteremail: "Enter email",
    enterpassword: "Enter password",
    forgotpassword: "Forgot Password",
    orviasocialmedia: "Or via social media",
    donthaveanaccount: "Don't have an account?",
    // signUpAplication.js
    application: "Application",
    fillInTheDetails: "Fill in the details and create your account",
    company: "Company",
    linkedIn: "LinkedIn",
    toKeepTheYesmlsPlatform: "To keep the YESMLS platform exclusively for Real-Estate professionals, we will verify your Sign Up information. Upon approval of your application you will be granted access.",
    next: "NEXT",

    //New Listing Input
    newListingInput: "NEW LISTING INPUT",
    editListingInput: "EDIT LISTING INPUT",
    listingType: "Listing Type",
    portfolioFeedGroup: "Portfolio Feed Group",
    Pictures: "Pictures",
    addImage: "Add Image",
    listingInfo: "Listing Info",
    plzAddImage: "Please add at least one image",

    //Listing Layout
    // listingLayout: "LISTING LAYOUT",
    consumerListingLayout: "Consumer - Listing Layout",
    activeFields: "Active Fields",
    inactiveFields: "Inactive Fields",
    search: "Quick Search",
    show: "Show",
    hide: "Hide",
    position: "Position",

    //Portfolio News
    all: "All",
    new: "New",
    priceChange: "Price Change",
    sold: "Sold",

    //My Feeds
    myFeeds: "My Feeds",
    viewF1: "Feed 1",
    viewF2: "Feed 2",
    viewF3: "Feed 3",
    viewF4: "Feed 4",
    viewFP: "Pocket Feed",

    //My Profile
    memberSince: "Member Since ",
    feedShared: "Feed Shared",
    feedReceived: "Feed Received",
    listing: "Listing",
    connections: "Connections",
    portfolio: "Portfolio",

    //My Profile
    memberSince: "Member Since ",
    feedShared: "Feed Shared",
    feedReceived: "Feed Received",
    listing: "Listing",
    connections: "Connections",
    portfolio: "Portfolio",
    memberBlocked: "Member Blocked",
    blockMember: "Block Member",
    unblockMember: "Unblock Member",
    feedOptions: "Feed Options",
    //home page 100%
    consumerAppsActive: "Consumer Apps Active",
    consumerAppFeeds: "Consumer App Feeds",
    infoRequest: "Info Requests",
    //apps Active
    appsActive: "Apps Active",
    lastAppUse: "Last app use",

    //FILTER APPLIED
    filterApplied: "FILTER APPLIED",
    country: "Country",
    state: "State",
    city: "City",
    propertyType: "Property Type",
    priceRange: "Price Range",
    rooms: "Rooms",
    bathrooms: "Bathrooms",

    //consumer app settings
    consumerAppSettings: "Consumer - App Settings",
    myfeed: "My Feed",
    multiFeed: "Multi Feed",
    myFeedActive: "My Listings Feed Active",
    multiFeedActive: "My Portfolio Feed Active",
    admin: "Admin",
    default: "Default",
    settings: "Settings",
    pic: "Picture",
    logo: "Logo",
    phone: "Phone",
    email: "Email",
    leads: "Leads",
    chooseAgent: "Choose Agent",
    consumerChooseAgent: "Consumer Chooses Agent",
    //info requests
    infoRequest: "INFO REQUESTS",
    active: "Active",
    completed: "Completed",
    //MEMBERS FEED ACTIVE
    memberFeedActive: "MEMBERS FEED ACTIVE",
    feedActive: "Feed Active",
    viewFeed: "View Feed",
    deleteFeed: "Delete Feed",
    //MEMBER FEED REQUEST SENT
    feedRequested: "Feed Requested",
    memberFeedRequestSent: "MEMBER FEED REQUEST SENT",
    feedRequestSent: "Feed Request Sent",
    viewFeedRequest: "View Feed Request",
    cancelFeedRequest: "Cancel Feed Request",
    //MY FEED SHARED
    myFeedShared: "My Feed Shared",
    generalFeed: "General Feed",
    individualFeed: "Individual Feed",
    //MY FEED PROPOSED
    myFeedProposed: "My Feed Proposed",
    feesSent: "Feed Sent",
    changeFeed: "Change Feed",
    //NEW LISTING RECEIVED
    newListingReceive: "Nouvelle listing reçue",
    //INCOMING MEMBER FEED
    incomingMemberFeed: "Incoming member feed",
    totalPublished: "Total Published",
    totalAccepted: "Total Accepted",
    totalShared: "Total Shared",
    accepted: "Accepted",
    published: "Published",
    unpublished: "Unpublished",
    //other pages
    memberFilter: "Member filter",
    plzSelctCountry: "Please select a country first",
    plzSelctState: "Please select a state first",
    blockedMembers: "Blocked Members",
    filterActive: "Filter Active",
    sponsorArea: "Sponsor\nArea",
    memberFeedFilter: "Member feed filter",
    scanCode: "Scan Code",
    //CONNECTION FEED SETTINGS
    connectionFeedSettings: "Connection feed settings",
    notShared: "Not Shared",
    total: "Total",
    shared: "Shared",
    accept: "Accepted",
    subscribed: "Subscribed",
    feed: "Feed",
    //PUSH NOTIFICATION
    pushNotification: "Notifications push",
    connectionRequest: "Connection Requests",
    newConnection: "New Connection",
    feedRequestReceived: "Feed Request Received",
    feedSharedAccepted: "Feed Shared Accepted",
    newAvailableListing: "New Available Listing",
    myPortfolioPriceChange: "My Portfolio Price Change",
    myPortfolioSold: "My Portfolio Sold",
    myPortfolioComingSoon: "My Portfolio Coming Soon",
    // /PORTFOLIO FILTER
    portfolioFilter: "Portefeuille filter",
    enterFilterName: "Enter Filter Name",
    price: "Price",
    min: "Min",
    max: "Max",
    bedrooms: "Bedrooms",
    //PORTFOLIO POOL FAVOURITE
    portfolioPoolFav: "Portefeuille favori",
    //ALERT DIALOG
    errorMsg: "Error, Please check",
    requestFrom: "Request from ",
    declineCRequest: "Decline connection request?",
    requestTo: "Request to ",
    cancelCRequest: "Cancel connection request?",
    confirmationMsg: "Confirmation",
    shareFeedMsg: "Are you sure you want to share your feed?",
    enterAllField: "Please enter all the required field!",
    logout: "Logout",
    logoutMsg: "Are you sure you want to logout ?",
    subscriptionMsg: "Get info about PREMIUM?",
    checkOutMsg: "Please check out ",
    deleteFilterMsg: "Are you sure you want to delete this filter?",
    feedFrom: "Feed from ",
    deleteFeedRequest: "Do you want to delete feed request?",
    declineFeedRequest: "Do you want decline feed request?",
    removedSucessfully: "Removed Successfully",
    invalidInput: "Invalid Input",
    noLinkAvailable: "No link available",
    removeListing: "Remove Listing",
    wantToRemoveListing: "Are you sure you want remove listing ?",
    plzAddProfileImage: "Please add profile image",
    plzAddCompanyLogo: "Please add company logo",
    plzAddCName: "Please add Company Name",
    plzAddTitle: "Please add Title - Function",
    plzAddFName: "Please add First Name",
    plzAddFamilyName: "Please add Family Name",
    plzAddCountry: "Please add Country",
    plzAddState: "Please add State",
    plzAddCity: "Please add City",
    plzAddZip: "Please add Zip Code",
    plzAddStreet: "Please add Street",
    plzAddNumber: "Please add Number",
    plzAddEmail: "Please add Email Address",
    plzAddCell: "Please add Cell Number",
    plzAddIntro: "Please add Short Intro",
    plzAddWMI: "Please add ‘Who am I’info",
    plzAddLinkedin: "Please add your LinkedIn / Website",
    notValidLinkedIn: "Not a valid LinkedIn address",
    notValidAppoLink: "Not a valid Calendly link",
    canNotEditEmail: "You can not edit email address",
    plzEnterRequiredField: "Please enter all the required fields!",
    maxPictureUploaded: "Maximum picture upload reached",
    unpublishFirst: "Please unpublish first",
    acceptFeedFirst: "Please accept the feed first",
    chooseOption: "Choose option",
    sendMyFeed: "Send My Feed",
    requestFeed: "Request Feed",
    blockThisMember: "Block this Member?",
    unBlockThisMember: "Unblock this Member?",
    removeConnection: "Remove connection?",

    plzCompleteProfile: "Please complete your profile details",

    // NOTIFICATIONS
    notifications: "NOTIFICATIONS",

    atleastOneAgent: 'You must choose at least one agent',
    websiteSettings: 'Website Settings',
    viewDetails: 'View Details',
    My: 'My',
    globalPortfolio: 'Global Portfolio',
    globalMembers: 'Global Members',
    inactiveListings: 'Inactive Listings',
    noNewListing24: 'No new listings in the last 24 hours!',
    noPriceChange24: 'No price changes in the last 24 hours!',
    noSold24: 'No sold listings in the last 24 hours!',
    abountMe: 'About Me',
    noAbout: "User didn't add this information yet!",
    searchByStreet: 'Search by Street',
    searchByName: 'Search by Name',
    searchByStreetAgent: 'Search by Street / Agent',
    noConnAvailable: "No connections available",
    newAvailable: 'New Available',
    createPortfolioFilter: 'Create filter',
    editPortfolioFilter: 'Edit filter',
    feedsReceived: 'Feeds Received',
    feedsRequested: 'Feeds Requested',
    myActiveFeeds: 'My Active Feeds',
    webSettings: "Web Settings",
    currentBannerImage: "Current Banner Image",
    changeBannerImage: "Change Banner Image",
    fromDefaultTheme: "From Default Theme",
    uploadYourImage: "Upload Your Image",
    bannerHeading: "Banner Heading",
    bannerSubHeading: "Banner Sub-Heading",
    cardHeading: "Card Heading",
    cardDescription: "Card Description",
    siteTitle: "Site Title",
    siteDescription: "Site Description",
    siteFavIcon: "Site Fav Icon",
    defaultLang: "Default Language",
    update: "Update",
    listingMatch: "Listing Match",
    clientMatch: "Client Match",
    showListing: "Show Listing",
    filterMatchWith: "Filter Match with:",
    feedRequestSettings: "Feed Request Settings",
    info: "Information",
    feedProposed: 'Feed Proposed',
    acceptFeed: "Accept Feed",
    declineFeed: "Decline Feed",
    contractDetails: "My cooperation terms and conditions",
    updatedSuccessfully: "Updated Successfully",
    searchByNameAndCompany: 'Search by Name / Company',
    listingInfoRequest: "Listing Information Request",
    myProfile: "My Profile",
    saveChanges: "Do you want to save the changes?",
    submit: "Submit",
    listingsInFeed: "Listings in feeds",
    agentCode: "Agent Code",
    premiumAgent: "Premium Agent",
    mySocialChannels: "My Social Channels",
    yearCreated: "Year Created",
    shareAndAcceptedBy: "Shared and accepted by",
    listingRequestSent: 'Listing Request Sent',
    cancelListingRequest: "Cancel Listing Request",
    Projects: "Projects",
    enterContractDetails: "Enter Contract Details",
    noBlockedMembers: "No Blocked Members",
    noFeedSentYet: "No feed sent yet",
    sendConnectionRequest: "Send connection request?",
    selectPhoto: "Select Photo",
    noneString: "None",
    deleteFeedMsg: "Do you want to delete this feed?",
    myFeedInfoDesc1: "Feeds are a collection of listings that can be shared with your connections with one click. It saves time and effort compared to sharing one listing at a time.",
    myFeedInfoDesc2: "It also has a subscribe feature that automatically suggests all new listings entered in this feed group to the feed connections.",
    myConnFilter: "My Connections Filter",
    favourites: "FAVOURITES",
    areYouSure: "Are you sure?",
    sendFeedRequest: "Send Feed Request",
    projectsPool: "Projects Pool",
    searchByDeveloperName: "Search by Developer Name",
    noListing: "No Listing",
    singleListing: "Listing",
    multipleListing: "Listings",
    projectDetails: "Project Details",
    searchByUnit: "Search by Unit Number",
    commissionDetails: "Commission Details",
    groupName: "Group Name",
    enterSellingPrice: "Enter Selling Price",
    commissionCalculator: "Commission Calculator",
    calculate: "Calculate",
    result: "Result",
    noofmembers: "No. of members",
    filter: "Filter",
    feedOptions: "Feed Options",
    contract: "Contract",
    addFilter: "Add Filter",
    deleteFilter: "Delete Filter",
    doYouWantToDeleteThisFilter: "Do you want to delete this filter?",
    edit: "Edit",
    delete: "Delete",
    editMemberFilter: "Edit Member Filter",
    createMemberFilter: "Create Member Filter",
    filterID: "Filter ID",
    selected: "Selected",
    youCanSelectMultiple: "You can select multiple",
    save: "Save",
    cancel: "Cancel",
    noRequestFound: "No Request Found",
    sendRequest: "Send Request",
    noBlockedMembersMatchYourSearch: "No blocked members match your search.",
    nooflistings: "Number of listings",
    inactiveListings: "Inactive Listings",
    activeListings: "Active Listings",
    addListings: "Add Listings",
    termsAndConditions: "Terms & Conditions",
    backToMyListings: "Back to My Listings",
    loading: "Loading...",
    noListingsMatchYourSearch: "No listings match your search.",
    noListingsFound: "No listings found.",
    contractDetails: "My cooperation terms and conditions",
    pleaseWaitWhileWeFetchThePropertyDetails: "Please wait while we fetch the property details.",
    view360: "360 view",
    shareOrGroup: "Share or group",
    folder: "Folder",
    gallery: "Gallery",
    removeFeedRequest: "Remove Feed Request",
    viewGallery: "View gallery",
    noOfPortfolio: "No. of portfolio",
    noListingsMatchYourSearch: "No listings match your search.",
    noListingsFound: "No listings found.",
    favorite: "Favorite",
    filterName: "Filter Name",
    minPrice: "Min Price",
    maxPrice: "Max Price",
    propertyType: "Property Type",
    bedroom: "Bedroom",
    bathroom: "Bathroom",
    noNewListingsInTheLast24Hours: "No new listings in the last 24 hours!",
    noPriceChangesInTheLast24Hours: "No price changes in the last 24 hours!",
    noSoldListingsInTheLast24Hours: "No sold listings in the last 24 hours!",
    changeEmailId: "Change Email Id",
    share: "Share",
    Website: "Website",
    logOut: "Log out",
    changePassword: "Change Password",
    oldPassword: "Old Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    oldEmail: "Old Email",
    newEmail: "New Email",
    companyWebsite: "Company Website",
    titleFunction: "Title - Function",
    gender: "Gender",
    licenceNumberCertification: "Licence Number - Certifications",
    contactDetails: "Contact Details",
    spokenLanguage: "Spoken Language",
    phoneNo: "Phone No.",
    emailId: "Email Id",
    shortIntroduction: "Short Introduction",
    aboutMe: "About Me",
    companyName: "Company Name",
    yearCreated: "Year Created",
    agentCode: "Agent Code",
    country: "Country",
    state: "State",
    city: "City",
    zipCode: "Zip Code",
    street: "Street",
    fromDefaultTheme: "From Default Theme",
    uploadYourImage: "Upload Your Image",
    weblink: "Weblink",
    decline: "Decline",
    areYouSureYouWantToCancelTheFeedRequest: "Are you sure you want to cancel the feed request?",
    cancelRequest: "Cancel request",
    viewMyShared: "View my shared",
    confirmation: "Confirmation",
    yes: "Yes",
    no: "No",
    connectionFeedSettings: "Connection Feed Settings",
    total: "Total",
    shared: "Shared",
    accepted: "Accepted",
    subscribed: "Subscribed",
    areYouSureYouWantToShareYourFeed: "Are you sure you want to share your feed?",
    checkingLink: "Checking link...",
    noLinkAvailable: "No link available",
    folder: "Folder",
    public: "Public",
    private: "Private",
    edit: "Edit",
    cancel: "Cancel",
    save: "Save",
    openLink: "Open link",
    add: "Add",
    connected: "Connected",
    premiumMembers: "Premium Members",
    consumerAppsActive: "Consumer Apps Active",
    consumerAppSettings: "Consumer App Settings",
    infoRequests: "Info Requests",
    agentSettings: "Agent Settings",
    noAgentsInThisFeed: "No agents in this feed.",
    list: "List",
    completedList: "Completed List",
    requestDate: "Request date",
    hasAListingWith: "has a listing with",
    hasAListing: "has a listing",
    filterMatchWith: "Filter Match with:",
    showListing: "Show Listing",
  },



  "fr": {
    // Member Edit screen (info_details.js)
    listings: "Mandats",
    connections: "Connections",
    portfolio: "Portefeuille",
    uploadNewProfilePicture: "Télécharger nouvelle photo de profil",
    uploadNewCompanyPicture: "Télécharger nouveau logo d'entreprise",
    personalInformation: "Informations personnelles",
    companyInformation: "Informations sur la société",
    male: "Homme",
    female: "Femme",
    other: "Autre",
    fName: "Prénom",
    lName: "Nom de famille",
    familyName: "Nom de famille",
    country: "Pays",
    state: "Province",
    city: "Ville",
    zipCode: "Code Postal",
    street: "Rue",
    number: "Numéro",
    contactInformation: "Informations de Contact",
    email: "E-mail",
    cellPhone: "Téléphone Portable",
    shortIntro: "Courte Introduction",
    language: "Langue",
    chooseLanguage: "Choisissez la langue",
    changeEmail: "Changer l'e-mail",
    changePassword: "Changer le mot de passe",
    closeEditMode: "Fermer le mode d'édition",
    logout: "Se déconnecter?",
    hey: "Salut",
    doYouWantToSaveYourInformation: "Sauvegarder les modifications?",   //given as 'Save Changes?'
    companyName: "Nom de l'entreprise",
    title: "Titre - Fonction *",
    licence: "Numéro de licence - Certification(s)",
    spokenLanguage: "Langue(s) parlée",
    agentCode: "Code d'agent    ",
    appointmentLink: "Lien Calendly (Optionnel)",
    whoami: "Over *",
    home: "Accueil",
    news: "Actualités",
    feed: "Feed",
    listingLayout: "Disposition du mandat",
    profile: "Profil",
    //home.js
    members: "MEMBRES",
    portfolio: "PORTEFEUILLE",
    // Information Pop up
    contactUs: "Nous contacter",
    cancel: "Annuler ",
    ok: "D'accord",
    yes: "Oui",
    no: "Non",
    sendEmail: "Envoyer e-mail",
    // members.js
    myconnection: "Mes connexions",
    connectionrequest: "DEMANDES",
    memberspool: "MEMBRES",

    // Connection requests
    requestReceived: "Demande reçue",
    requestSent: "Demande envoyée",
    //portfolio.js
    portfoliofeeds: "FEEDS DE PORTEFEUILLE",
    portfolionews: "Actualités du portefeuille 24h",
    listings_portfolio: "MANDATS - PORTEFEUILLE",
    //portfolio_feed.js
    receivedactivefeeds: "FEED ACTIVE REÇU",
    availablelistings: "MANDATS DISPONIBLES",
    sharedactivefeeds: "FEED ACTIVE PARTAGÉ",
    //listing_portfolio.js
    mylistings: "Mes Mandats",
    myportfolio: "Mon Portefeuille",
    portfoliopool: "Portefeuille",
    // Portfolio Pool Filters
    filterName: "Nom du filtre",
    inactive: "Inactif",
    public: "Public",
    pocket: "Caché",
    //-----------------------------------------------------------------
    //New Listing Input
    newListingInput: "NOUVELLE ENTRÉE MANDAT",
    editListingInput: "MODIFIER MANDAT",
    listingType: "Type de mandat",
    portfolioFeedGroup: "Portefeuille feed groupe",
    Pictures: "Photos",
    addImage: "Ajouter une photo",
    listingInfo: "Infos du mandat",
    plzAddImage: "Veuillez ajouter au moins une image",
    //Listing LayconsumerListingLayoutout
    // listingLayout: "Disposition du mandat",
    consumerListingLayout: "APP CLIËNT - DISPOSITION DU MANDAT",
    activeFields: "Champs de données actifs",
    inactiveFields: "Champs de données inactifs",
    search: "Recherche rapide",
    show: "Montrer",
    hide: "Cacher",
    position: "Position",

    //Portfolio News
    all: "Tout",
    new: "Nouveau",
    priceChange: "Prix",
    sold: "Vendu",

    //My Feeds
    myFeeds: "Mes feeds",
    viewF1: "Feed 1",
    viewF2: "Feed 2",
    viewF3: "Feed 3",
    viewF4: "Feed 4",
    viewFP: "Feed Caché",

    //My Profile
    memberSince: "Membre depuis ",
    feedShared: "Feed partagé",
    feedReceived: "Feed reçu",
    listing: "MANDATS",
    connections: "CONNEXIONS",
    memberBlocked: "Membre bloqué",
    blockMember: "Bloquer le membre",
    unblockMember: "Débloquer le membre",
    //home page 100%
    consumerAppsActive: "APPS CONSOMMATEUR ACTIF",
    consumerAppFeeds: "CONSOMMATEUR APP FEEDS",
    infoRequest: "DEMANDES D'INFO",
    //apps Active
    appsActive: "APPS ACTIVE",
    lastAppUse: "Dernière utilisation",
    //FILTER APPLIED
    filterApplied: "FILTRE APPLIQUÉ",
    country: "Région",
    state: "Etat",
    city: "Ville",
    propertyType: "Type de propriété",
    priceRange: "Échelle des prix",
    rooms: "Pièces",
    bathrooms: "Salles de bain",
    //consumer app settings
    consumerAppSettings: "PARAMÈTRES DE L'APPLICATION CONSOMMATEUR",
    myfeed: "Mon Feed",
    multiFeed: "Feed multiple",
    myFeedActive: "Flux Mes annonces actif",
    multiFeedActive: "Mon flux de portefeuille actif",
    admin: "Admin",
    default: "Défaut",
    settings: "Paramètres",
    pic: "Image",
    logo: "Logo",
    phone: "Téléphone",
    email: "Email",
    leads: "Opportunités",
    chooseAgent: "Choisissez un agent",
    consumerChooseAgent: "Le consommateur choisit l'agent",
    //info requests
    infoRequest: "DEMANDES D'INFO",
    active: "Actif",
    completed: "Complété",
    //MEMBERS FEED ACTIVE
    memberFeedActive: "FEED MEMBRES ACTIF",
    feedActive: "Feed actif",
    viewFeed: "Afficher le feed",
    deleteFeed: "Supprimer le feed,",
    //MEMBER FEED REQUEST SENT
    feedRequested: "Flux demandé",
    memberFeedRequestSent: "DEMANDE DU FEED DE MEMBRES ENVOYÉE",
    feedRequestSent: "Demande de feed envoyée",
    viewFeedRequest: "Afficher la demande du feed",
    cancelFeedRequest: "Annuler la demande du feed",
    //MY FEED SHARED
    myFeedShared: "Mon feed partagé",
    generalFeed: "Feed général",
    individualFeed: "Feed individuelle",
    //MY FEED PROPOSED
    myFeedProposed: "Mon feed proposé",
    feesSent: "Feed envoyé",
    changeFeed: "Modifier le feed",
    //NEW LISTING RECEIVED
    newListingReceive: "Nouvelle mandat reçue",
    //INCOMING MEMBER FEED
    incomingMemberFeed: "Feed reçu des membres",
    totalPublished: "Total publié",
    totalAccepted: "Total accepté",
    totalShared: "Total partagé",
    accepted: "Accepté",
    published: "Publié",
    unpublished: "Non publié",
    //other pages
    memberFilter: "Filtre membre",
    plzSelctCountry: "Veuillez d'abord sélectionner un pays",
    plzSelctState: "Veuillez d'abord sélectionner un état",
    blockedMembers: "Membres bloqués",
    filterActive: "Filtre actif",
    sponsorArea: "Espace\nCommanditaire",
    memberFeedFilter: "Filtre feed des membres",
    scanCode: "Scan la code",

    //CONNECTION FEED SETTINGS
    connectionFeedSettings: "Paramètres feed de connexion",
    notShared: "Non partagé",
    total: "Total",
    shared: "partagé",
    accept: "Accepté",
    subscribed: "Abonné",
    feed: "Feed",
    //PUSH NOTIFICATION
    pushNotification: "Notifications push",
    connectionRequest: "Demande de connexion",
    newConnection: "Nouvelle connexion",
    feedRequestReceived: "Demande de feed reçue",
    feedSharedAccepted: "Feed partagé accepté",
    newAvailableListing: "Nouvelle mandat disponible",
    myPortfolioPriceChange: "Mandat Prix Changé",
    myPortfolioSold: "Mandats vendu",
    myPortfolioComingSoon: "Mandats arrive bientôt",
    // /PORTFOLIO FILTER
    portfolioFilter: "Filtre portefeuille",
    enterFilterName: "Entrez le nom du filtre",
    price: "Prix",
    min: "Min",
    max: "Max",
    bedrooms: "Chambres",
    //PORTFOLIO POOL FAVOURITE
    portfolioPoolFav: "Portefeuille favori",
    //ALERT DIALOG
    errorMsg: "Erreur, veuillez vérifier",
    requestFrom: "Demande de ",
    declineCRequest: "Refuser la demande de connexion?",
    requestTo: "Demande à ",
    cancelCRequest: "Annuler la demande de connexion?",
    confirmationMsg: "Confirmation",
    shareFeedMsg: "Voulez-vous vraiment partager votre feed?",
    enterAllField: "SVP, veuillez entrer tous les données!",
    logout: "Se déconnecter",
    logoutMsg: "Êtes-vous sûr de vouloir vous déconnecter?",
    subscriptionMsg: "Obtenir des informations sur PREMIUM?",
    checkOutMsg: "Veuillez vérifier s'il vous plait",
    deleteFilterMsg: "Voulez-vous vraiment supprimer ce filtre?",
    feedFrom: "Feed de ",
    deleteFeedRequest: "Voulez-vous supprimer la demande de flux ?",
    declineFeedRequest: "Voulez-vous refuser la demande de feed?",
    removedSucessfully: "Supprimé avec succès",
    invalidInput: "Entrée faux",
    noLinkAvailable: "Aucun lien disponible",
    removeListing: "Supprimer l'annonce",
    wantToRemoveListing: "Voulez-vous vraiment supprimer le mandat?",
    plzAddProfileImage: "Veuillez ajouter une image de profil",
    plzAddCompanyLogo: "Veuillez ajouter le logo de l'entreprise",
    plzAddCName: "Veuillez remplir le nom de l'entreprise",
    plzAddTitle: "Veuillez remplir Titre - Fonction(s)",
    plzAddFName: "Veuillez remplir le prénom",
    plzAddFamilyName: "Veuillez remplir le nom de famille",
    plzAddCountry: "Veuillez remplir le pays",
    plzAddState: "Veuillez remplir l'état",
    plzAddCity: "Veuillez remplir la ville",
    plzAddZip: "Veuillez remplir le code postal",
    plzAddStreet: "Veuillez remplir la rue",
    plzAddNumber: "Veuillez remplir le numéro",
    plzAddEmail: "Veuillez remplir votre adresse e-mail",
    plzAddCell: "Veuillez remplir le numéro de téléphone",
    plzAddIntro: "Veuillez remplir la courte introduction",
    plzAddWMI: "Veuillez remplir ‘Qui suis-je’",
    plzAddLinkedin: "Veuillez ajouter votre LinkedIn / site Web",
    notValidLinkedIn: "Pas une adresse LinkedIn valide",
    notValidAppoLink: "Lien de Calendly faux",
    canNotEditEmail: "Vous ne pouvez pas modifier l'adresse e-mail",
    plzEnterRequiredField: "Veuillez saisir tous les données obligatoires!",
    maxPictureUploaded: "Téléchargement maximal de photos atteint",
    unpublishFirst: "Veuillez d'abord annuler la publication",
    acceptFeedFirst: "Veuillez d'abord accepter le feed",
    chooseOption: "Choisissez une option",
    sendMyFeed: "Envoyer mon feed",
    requestFeed: "Demander un feed",
    blockThisMember: "Bloquer ce membre?",
    unBlockThisMember: "Débloquer ce membre?",
    removeConnection: "Supprimer la connexion?",

    plzCompleteProfile: "Veuillez compléter les détails de votre profil",

    // NOTIFICATIONS
    notifications: "avis",


    atleastOneAgent: 'Vous devez choisir au moins un agent',
    websiteSettings: 'Website Settings',

    viewDetails: 'Voir les détails',
    My: 'Mes',
    globalPortfolio: 'Portefeuille mondial',
    globalMembers: 'Membres mondiaux',
    inactiveListings: 'ANNONCES INACTIVES',
    noNewListing24: 'Aucune nouvelle annonce dans les dernières 24 heures !',
    noPriceChange24: 'Aucun changement de prix dans les dernières 24 heures !',
    noSold24: 'Aucune annonce vendue au cours des dernières 24 heures !',
    abountMe: 'Sur moi',
    noAbout: "L'utilisateur n'a pas encore ajouté cette information !",
    searchByStreet: 'Rechercher par rue',
    searchByName: 'Rechercher par nom',
    searchByStreetAgent: 'Recherche par Rue / Agent',
    noConnAvailable: "Aucune connexion disponible",
    newAvailable: 'Nouveau disponible',
    createPortfolioFilter: 'Créer un filtre',
    editPortfolioFilter: 'Modifier le filtre',
    feedsReceived: 'Flux reçus',
    feedsRequested: 'Flux demandés',
    myActiveFeeds: 'Mes flux actifs',

    webSettings: "Paramètres Web",
    currentBannerImage: "Image de la bannière actuelle",
    changeBannerImage: "Modifier l'image de la bannière",
    fromDefaultTheme: "À partir du thème par défaut",
    uploadYourImage: "Téléchargez votre image",
    bannerHeading: "Titre de la bannière",
    bannerSubHeading: "Sous-titre de la bannière",
    cardHeading: "Titre de la carte",
    cardDescription: "Description de la carte",
    siteTitle: "Titre du site",
    siteDescription: "Description du site",
    siteFavIcon: "Icône de favori du site",
    defaultLang: "Langage par défaut",
    update: "Mise à jour",
    listingMatch: "Correspondance d'annonce",
    clientMatch: "Mise en relation client",
    showListing: "Afficher la liste",
    filterMatchWith: "Filtrer la correspondance avec :",
    feedRequestSettings: "PARAMÈTRES DE DEMANDE D'ALIMENTATION",
    info: "Information",
    feedProposed: 'Flux proposé',
    acceptFeed: "Accepter le flux",
    declineFeed: "Refuser le flux",
    contractDetails: "Mes termes et conditions de coopération",
    updatedSuccessfully: "Mis à jour avec succés",

    searchByNameAndCompany: 'Recherche par nom / entreprise',
    listingInfoRequest: "Demande d'informations sur l'inscription",
    myProfile: "Mon profil",
    saveChanges: "Souhaitez-vous enregistrer les modifications ?",
    submit: "Soumettre",
    listingsInFeed: "Annonces dans les flux",
    agentCode: "Code agent",
    premiumAgent: "Agent supérieur",
    mySocialChannels: "Mes réseaux sociaux",
    yearCreated: "Année de création",
    shareAndAcceptedBy: "Partagé et accepté par",
    listingRequestSent: "Demande d'inscription envoyée",
    cancelListingRequest: "Annuler la demande d'inscription",
    Projects: "Projets",
    enterContractDetails: "Saisir les détails du contrat",
    noBlockedMembers: "Aucun membre bloqué",
    noFeedSentYet: "Aucun flux envoyé pour le moment",
    sendConnectionRequest: "Envoyer une demande de connexion ?",
    selectPhoto: "Sélectionnez une photo",
    noneString: "Aucun",
    deleteFeedMsg: "Voulez-vous supprimer ce flux ?",
    feedShareWith: "Feed shared with ",
    myFeedInfoDesc1: "Les flux sont un ensemble de listes qui peuvent être partagées avec vos connexions en un seul clic. Cela permet d'économiser du temps et des efforts par rapport au partage d'une annonce à la fois.",
    myFeedInfoDesc2: "Il dispose également d'une fonction d'abonnement qui suggère automatiquement toutes les nouvelles annonces saisies dans ce groupe de flux aux connexions de flux.",
    myConnFilter: "Filtre Mes connexions",
    favourites: "FAVORIS",
    areYouSure: "Es-tu sûr?",
    sendFeedRequest: "Envoyer une demande de flux",
    projectsPool: "Pool de projets",
    searchByDeveloperName: "Rechercher par nom de développeur",
    noListing: "Aucune annonce",
    singleListing: "Référencement",
    multipleListing: "Annonces",
    projectDetails: "détails du projet",
    searchByUnit: "Recherche par numéro d'unité",
    commissionDetails: "Détails des commissions",
    groupName: "Nom de groupe",
    enterSellingPrice: "Entrez le prix de vente",
    commissionCalculator: "Calculateur de commissions",
    calculate: "Calculer",
    result: "Résultat",
    noofmembers: "Nombre de membres",
    filter: "Filtre",
    feedOptions: "Feed Opties",
    contract: "Contracter",
    addFilter: "Filtre ajouter",
    deleteFilter: "Filtre supprimer",
    doYouWantToDeleteThisFilter: "Voulez-vous supprimer ce filtre?",
    edit: "Modifier",
    delete: "Supprimer",
    editMemberFilter: "Modifier le filtre",
    createMemberFilter: "Créer un filtre",
    filterID: "ID du filtre",
    selected: "Sélectionné",
    youCanSelectMultiple: "Vous pouvez sélectionner plusieurs",
    save: "Enregistrer",
    cancel: "Annuler",
    noRequestFound: "Aucune demande trouvée",
    sendRequest: "Envoyer la demande",
    noBlockedMembersMatchYourSearch: "Aucun membre bloqué correspond à votre recherche.",
    nooflistings: "Nombre de listings",
    inactiveListings: "Annonces inactives",
    activeListings: "Annonces actives",
    addListings: "Ajouter des listings",
    termsAndConditions: "Conditions d'utilisation",
    backToMyListings: "Retour aux listes",
    loading: "Chargement...",
    noListingsMatchYourSearch: "Aucune liste correspondant à votre recherche.",
    noListingsFound: "Aucune liste trouvée.",
    contractDetails: "Mes termes et conditions de coopération",
    pleaseWaitWhileWeFetchThePropertyDetails: "Veuillez patienter pendant que nous récupérons les détails de la propriété.",
    view360: "Vue 360",
    shareOrGroup: "Partager ou grouper",
    folder: "Dossier",
    gallery: "Galerie",
    removeFeedRequest: "Supprimer la demande de flux",
    viewGallery: "Voir la galerie",
    noOfPortfolio: "Nombre de portfolio",
    noListingsMatchYourSearch: "No listings match your search.",
    noListingsFound: "No listings found.",
    favorite: "Favorite",
    filterName: "Filter Name",
    minPrice: "Min Price",
    maxPrice: "Max Price",
    propertyType: "Property Type",
    bedroom: "Bedroom",
    bathroom: "Bathroom",
    noNewListingsInTheLast24Hours: "Aucune nouvelle annonce au cours des dernières 24 heures !",
    noPriceChangesInTheLast24Hours: "Aucun changement de prix au cours des dernières 24 heures !",
    noSoldListingsInTheLast24Hours: "Aucune annonce vendue au cours des dernières 24 heures !",
    changeEmailId: "Changer l'e-mail",
    share: "Partager",
    Website: "Site Web",
    logOut: "Se déconnecter",
    changePassword: "Changer le mot de passe",
    oldPassword: "Ancien mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    oldEmail: "Ancien e-mail",
    newEmail: "Nouveau e-mail",
    companyWebsite: "Website de la société",
    titleFunction: "Titre - Fonction",
    gender: "Genre",
    licenceNumberCertification: "Numéro de licence - Certifications",
    contactDetails: "Détails de contact",
    spokenLanguage: "Langue parlée",
    phoneNo: "Numéro de téléphone",
    emailId: "E-mail",
    shortIntroduction: "Introduction courte",
    aboutMe: "À propos de moi",
    companyName: "Nom de la société",
    yearCreated: "Année de création",
    agentCode: "Code agent",
    country: "Pays",
    state: "Province",
    city: "Ville",
    zipCode: "Code postal",
    street: "Rue",
    fromDefaultTheme: "À partir du thème par défaut",
    uploadYourImage: "Téléchargez votre image",
    weblink: "Lien web",
    decline: "Refuser",
    areYouSureYouWantToCancelTheFeedRequest: "Tem certeza de que deseja cancelar a solicitação de feed?",
    cancelRequest: "Cancelar solicitação",
    viewMyShared: "Visualizar meu compartilhado",
    confirmation: "Confirmação",
    yes: "Sim",
    no: "Não",
    connectionFeedSettings: "Configurações de feed de conexão",
    total: "Total",
    shared: "Compartilhado",
    accepted: "Aceito",
    subscribed: "Inscrito",
    areYouSureYouWantToShareYourFeed: "Tem certeza de que deseja compartilhar seu feed?",
    checkingLink: "Verificando link...",
    noLinkAvailable: "Nenhum link disponível",
    folder: "Pasta",
    public: "Público",
    private: "Privado",
    edit: "Editar",
    cancel: "Cancelar",
    save: "Salvar",
    openLink: "Abrir link",
    add: "Adicionar",
    connected: "Conectado",
    premiumMembers: "Membros Premium",
    consumerAppsActive: "Applications grand public actives",
    consumerAppSettings: "Paramètres de l'application consommateur",
    infoRequests: "Solicitações de Informação",
    agentSettings: "Configurações do Agente",
    noAgentsInThisFeed: "Nenhum agente neste feed.",
    list: "Listar",
    completedList: "Lista Completa",
    requestDate: "Data da solicitação",
    hasAListingWith: "tem uma lista com",
    hasAListing: "tem uma lista",
    filterMatchWith: "Filtrar correspondência com:",
    showListing: "Mostrar listagem",
  },



  "Du": {
    // Member Edit screen (info_details.js)
    listings: "Inkopen",
    connections: "Connecties",
    portfolio: "Portefeuille",
    uploadNewProfilePicture: "Nieuwe profielfoto uploaden",
    uploadNewCompanyPicture: "Nieuw bedrijfslogo uploaden",
    personalInformation: "Persoonlijke informatie ",
    companyInformation: "Bedrijfsinformatie",
    male: "Man",
    female: "Vrouw",
    other: "Andere",
    fName: "Voornaam",
    lName: "Familienaam",
    familyName: "Familienaam",
    country: "Land",
    state: "Provincie",
    city: "Stad",
    zipCode: "Postcode",
    street: "Straat",
    number: "Nummer",
    contactInformation: "Contact Informatie",
    cellPhone: "Mobiel Nummer",
    shortIntro: "Korte Introductie",
    language: "Taal",
    chooseLanguage: "Kies uw taal",
    changeEmail: "Wijzig Email",
    changePassword: "Wijzig wachtwoord",
    closeEditMode: "Sluit editeer modus",
    logout: "Uitloggen?",
    hey: "Hoi",
    doYouWantToSaveYourInformation: "Wijzigingen opslaan?",   //given as 'Save Changes?'
    companyName: "Bedrijfsnaam",
    title: "Titel - Functie *",
    licence: "Licentienummer - Certificatie(s)",
    spokenLanguage: "Gesproken taal/talen",
    home: "Start",
    news: "Nieuws",
    feed: "Feed",
    listingLayout: "Inkoop Lay-out",
    profile: "Profiel",
    agentCode: "Agentcode",
    appointmentLink: "Calendly Link (Optioneel)",
    whoami: "À propos de *",
    //home.js
    members: "LEDEN",
    portfolio: "Portefeuille",
    // Information Pop up
    contactUs: "Ons contacteren",
    cancel: "Annuleren",
    ok: "OK",
    yes: "Ja",
    no: "Nee",
    sendEmail: "Email verzenden",
    // members.js
    myconnection: "Mijn Connecties",
    connectionrequest: "Verzoek",
    memberspool: "LEDEN",

    // Connection requests
    requestReceived: "Aanvraag ontvangen",
    requestSent: "Aanvraag verzonden",
    //portfolio.js
    portfoliofeeds: "PORTEFEUILLE FEEDS",
    portfolionews: "24 uur Portfolio Nieuws",
    listings_portfolio: "INKOPEN - PORTEFEUILLE",
    //portfolio_feed.js
    receivedactivefeeds: "ONTVANGEN ACTIEVE FEEDS",
    availablelistings: "BESCHIKBARE INKOPEN",
    sharedactivefeeds: "GEDEELDE ACTIEVE FEEDS",
    //listing_portfolio.js
    mylistings: "Mijn Inkopen",
    myportfolio: "Mon Portefeuille",
    portfoliopool: "Portefeuille",

    // Portfolio Pool Filters
    filterName: "Filter naam",
    inactive: "Inactief",
    public: "Publiek",
    pocket: "Verborgen",
    //-----------------------------------------------------------------
    //New Listing Input
    newListingInput: "INVOER NIEUWE INKOOP",
    editListingInput: "INKOOP BEWERKEN",
    listingType: "INKOOP TYPE",
    portfolioFeedGroup: "Portefeuille Feed Groep",
    Pictures: "Afbeeldingen",
    addImage: "Voeg afbeelding toe",
    listingInfo: "Inkoop Info",
    plzAddImage: "Voeg ten minste één afbeelding toe",

    //Listing Layout
    // listingLayout: "INKOOP LAY-OUT ",
    consumerListingLayout: "KLANTEN APP LAY-OUT ",
    activeFields: "Actieve velden",
    inactiveFields: "Inactieve velden",
    search: "Snelzoeken",
    show: "Zichtbaar",
    hide: "Onzichtbaar",
    position: "Positie",

    //Portfolio News
    all: "Alle",
    new: "Nieuw",
    priceChange: "Prijs",
    sold: "Verkocht",

    //My Feeds
    myFeeds: "MIJN FEEDS",
    viewF1: "Feed 1",
    viewF2: "Feed 2",
    viewF3: "Feed 3",
    viewF4: "Feed 4",
    viewFP: "Pocketfeed",

    //My Profile
    memberSince: "Lid sinds ",
    feedShared: "Feed gedeeld",
    feedReceived: "Ontvangen feed",
    addConnection: "Connectie toevoegen",
    removeConnection: "Connectie verwijderen",
    listing: "INKOPEN",
    connections: "Connecties",
    memberBlocked: "LID GEBLOKKEERD",
    blockMember: "Lid blokkeren",
    unblockMember: "Lid ontgrendelen",
    //home page 100%
    consumerAppsActive: "KLANTEN APPS ACTIEF",
    consumerAppFeeds: "KLANTEN APP FEEDS",
    infoRequest: "INFO AANVRAGEN",

    //apps Active
    appsActive: "KLANTEN APPS ACTIEF",
    lastAppUse: "Laatst gebruikt",

    //FILTER APPLIED
    filterApplied: "FILTER TOEGEPAST",
    country: "Land",
    state: "Staat",
    city: "Stad",
    propertyType: "Type Eigendom",
    priceRange: "Prijsbereik",
    rooms: "Kamers",
    bathrooms: "Badkamers",
    //consumer app settings
    consumerAppSettings: "INSTELLINGEN KLANTEN APP",
    myfeed: "Mijn feed",
    multiFeed: "Multi Feed",
    myFeedActive: "Mijn aanbiedingen Feed actief",
    multiFeedActive: "Mijn portfoliofeed actief",
    admin: "Beheerder",
    default: "Standaard",
    settings: "Instellingen",
    pic: "Afbeelding",
    logo: "Logo",
    phone: "Telefoon",
    email: "E-mail",
    leads: "Opportuniteiten",
    chooseAgent: "Kies Agent",
    consumerChooseAgent: "Consument kiest makelaar",
    //info requests
    infoRequest: "INFO AANVRAGEN",
    active: "Te Koop",
    completed: "Voltooid",
    //MEMBERS FEED ACTIVE
    memberFeedActive: "Actieve ontvangen feeds",
    feedActive: "Feed actief",
    viewFeed: "Feed bekijken",
    deleteFeed: "Feed verwijderen",
    //MEMBER FEED REQUEST SENT
    feedRequested: "Feed aangevraagd",
    memberFeedRequestSent: "Feedverzoek verzonden",
    feedRequestSent: "Feedverzoek verzonden",
    viewFeedRequest: "Feedaanvraag bekijken",
    cancelFeedRequest: "Feedverzoek annuleren",
    //MY FEED SHARED
    myFeedShared: "Mijn gedeelde feeds",
    generalFeed: "Algemene Feed",
    individualFeed: "Individuele Feed",
    //MY FEED PROPOSED
    myFeedProposed: "Mijn feed aangeboden",
    feesSent: "Feed verzonden",
    changeFeed: "Feed wijzigen",
    //NEW LISTING RECEIVED
    newListingReceive: "Nieuwe inkoop ontvangen",
    //INCOMING MEMBER FEED
    incomingMemberFeed: "Inkomende feed",
    totalPublished: "Totaal gepubliceerd",
    totalAccepted: "Totaal geaccepteerd",
    totalShared: "Totaal gedeeld",
    accepted: "Geaccepteerd",
    published: "Gepubliceerd",
    unpublished: "Niet gepubliceerd",
    //other pages
    memberFilter: "Lid filter",
    plzSelctCountry: "Selecteer eerst een land",
    plzSelctState: "Selecteer eerst een staat",
    blockedMembers: "Geblokeerde leden",
    filterActive: "Filter actief",
    sponsorArea: "Sponsorgebied",
    memberFeedFilter: "Lid feed filter",
    scanCode: "Scan Code",
    //CONNECTION FEED SETTINGS
    connectionFeedSettings: "Connectie feed instellingen",
    notShared: "Niet gedeeld",
    total: "Totaal",
    shared: "Gedeeld",
    accept: "Geaccepteerd",
    subscribed: "Geabonneerd",
    feed: "Feed",
    //PUSH NOTIFICATION
    pushNotification: "Push-meldingen",
    connectionRequest: "Connectieverzoek",
    newConnection: "Nieuwe Connectie",
    feedRequestReceived: "Feedverzoek ontvangen",
    feedSharedAccepted: "Gedeelde feed geaccepteerd",
    newAvailableListing: "Nieuwe beschikbare Inkoop",
    myPortfolioPriceChange: "Prijswijziging",
    myPortfolioSold: "Verkocht",
    myPortfolioComingSoon: "Binnenkort te koop",

    // /PORTFOLIO FILTER
    portfolioFilter: "Portefeuille filter",
    enterFilterName: "Voer Filternaam in",
    price: "Prijs",
    min: "Min",
    max: "Max",
    bedrooms: "Slaapkamers",
    //PORTFOLIO POOL FAVOURITE
    portfolioPoolFav: "Portefeuille favoriet",
    //ALERT DIALOG
    errorMsg: "Fout, controleer",
    requestFrom: "Aanvraag van ",
    declineCRequest: "Connectieverzoek weigeren?",
    requestTo: "Verzoek aan ",
    cancelCRequest: "Connectieverzoek annuleren?",
    confirmationMsg: "Bevestiging",
    shareFeedMsg: "Weet je zeker dat je uw feed wilt delen?",
    enterAllField: "Gelieve alle verplichte velden in te vullen",
    logout: "Uitloggen",
    logoutMsg: "Weet je zeker dat je wilt uitloggen?",
    subscriptionMsg: "Wens je info over PREMIUM?",
    checkOutMsg: "Uitloggen",
    deleteFilterMsg: "Weet je zeker dat je deze filter wilt verwijderen?",
    feedFrom: "Feed van ",
    deleteFeedRequest: "Wilt u het feedverzoek verwijderen?",
    declineFeedRequest: "Wilt u een feedaanvraag weigeren?",
    removedSucessfully: "Succesvol verwijderd",
    invalidInput: "Ongeldige invoer",
    noLinkAvailable: "Geen link beschikbaar",
    removeListing: "Vermelding verwijderen",
    wantToRemoveListing: "Weet u zeker dat u de vermelding wilt verwijderen?",
    plzAddProfileImage: "Voeg een profielafbeelding toe",
    plzAddCompanyLogo: "Voeg bedrijfslogo toe",
    plzAddCName: "Vul bedrijfsnaam in",
    plzAddTitle: "Vul titel - functie in",
    plzAddFName: "Vul uw voornaam in",
    plzAddFamilyName: "Vul uw achternaam in",
    plzAddCountry: "Vul land in",
    plzAddState: "Vul staat in",
    plzAddCity: "Vul stad in",
    plzAddZip: "Vul postcode in",
    plzAddStreet: "Vul straat in",
    plzAddNumber: "Vul nummer in",
    plzAddEmail: "Vul e-mailadres in",
    plzAddCell: "Vul telefoonnummer in",
    plzAddIntro: "Vul uw korte introductie in",
    plzAddWMI: "Gelieve in te vullen - Wie ben ik",
    plzAddLinkedin: "Voeg uw LinkedIn / website toe",
    notValidLinkedIn: "Geen geldig LinkedIn-adres",
    notValidAppoLink: "Geen geldige Calendly-link",
    canNotEditEmail: "U kunt geen e-mailadres bewerken",
    plzEnterRequiredField: "Gelieve alle verplichte velden in te vullen!",
    maxPictureUploaded: "Maximale foto-upload bereikt",
    unpublishFirst: "Maak éérst de publicatie ongedaan",
    acceptFeedFirst: "Accepteer éérst de feed",
    chooseOption: "Kies een optie",
    sendMyFeed: "Stuur mijn feed",
    requestFeed: "Feed aanvragen",
    blockThisMember: "Dit lid blokkeren?",
    unBlockThisMember: "Dit lid deblokkeren?",
    removeConnection: "Connectie verwijderen?",

    plzCompleteProfile: "Vul uw profielgegevens in",

    // NOTIFICATIONS
    notifications: "meldingen",


    atleastOneAgent: 'U moet ten minste één agent kiezen',
    websiteSettings: 'Website Settings',
    viewDetails: 'Details bekijken',
    My: 'Mijn',
    globalPortfolio: 'Wereldwijde portefeuille',
    globalMembers: 'Wereldwijde leden',
    inactiveListings: 'INACTIEVE LIJSTEN',
    noNewListing24: 'Geen nieuwe advertenties in de afgelopen 24 uur!',
    noPriceChange24: 'Geen prijswijzigingen in de afgelopen 24 uur!',
    noSold24: 'Geen verkochte advertenties in de afgelopen 24 uur!',
    abountMe: 'Over mij',
    noAbout: "De gebruiker heeft deze informatie nog niet toegevoegd!",
    searchByStreet: 'Zoek op straat',
    searchByName: 'Zoek op naam',
    searchByStreetAgent: 'Zoek op Straat / Agent',
    noConnAvailable: "Geen aansluitingen beschikbaar",
    newAvailable: 'Nieuw beschikbaar',
    createPortfolioFilter: 'Filter maken',
    editPortfolioFilter: 'Filter bewerken',
    feedsReceived: 'Feeds ontvangen',
    feedsRequested: 'Feeds gevraagd',
    myActiveFeeds: 'Mijn actieve feeds',

    webSettings: "Webinstellingen",
    currentBannerImage: "Huidige bannerafbeelding",
    changeBannerImage: "Bannerafbeelding wijzigen",
    fromDefaultTheme: "Van standaardthema",
    uploadYourImage: "Upload uw afbeelding",
    bannerHeading: "Bannerkop",
    bannerSubHeading: "Banner subkop",
    cardHeading: "Kaartkop",
    cardDescription: "Kaartbeschrijving",
    siteTitle: "Pagina Titel",
    siteDescription: "Beschrijving van de Site",
    siteFavIcon: "Favicon van de site",
    defaultLang: "Standaard taal",
    update: "Update",
    listingMatch: "Advertentiematch",
    clientMatch: "Cliëntmatch",
    showListing: "Lijst tonen",
    filterMatchWith: "Filterovereenkomst met:",
    feedRequestSettings: "INSTELLINGEN VOERVERZOEK",
    info: "Informatie",
    feedProposed: 'Voer voorgesteld',
    acceptFeed: "Accepteer voer",
    declineFeed: "Refuser le flux",
    contractDetails: "Mijn samenwerkingsvoorwaarden",
    updatedSuccessfully: "succesvol geupdatet",
    searchByNameAndCompany: 'Zoek op Naam / Bedrijf',
    listingInfoRequest: "Vermelding informatieverzoek",
    myProfile: "Mijn profiel",
    saveChanges: "Wilt u de wijzigingen opslaan?",
    submit: "Indienen",
    listingsInFeed: "Vermeldingen in feeds",
    agentCode: "Agentcode",
    premiumAgent: "Premium-agent",
    mySocialChannels: "Mijn sociale kanalen",
    yearCreated: "Jaar gemaakt",
    shareAndAcceptedBy: "Gedeeld en geaccepteerd door",
    listingRequestSent: "Advertentieverzoek verzonden",
    cancelListingRequest: "Advertentieaanvraag annuleren",
    Projects: "Projecten",
    enterContractDetails: "Voer contractgegevens in",
    noBlockedMembers: "Geen geblokkeerde leden",
    noFeedSentYet: "Nog geen feed verzonden",
    sendConnectionRequest: "Connectieverzoek versturen?",
    selectPhoto: "Selecteer Foto",
    noneString: "Geen",
    deleteFeedMsg: "Wilt u deze feed verwijderen?",
    feedShareWith: "Feed gedeeld met ",
    myFeedInfoDesc1: "Feeds zijn een verzameling vermeldingen die met één klik met uw connecties kunnen worden gedeeld. Het bespaart tijd en moeite vergeleken met het delen van één advertentie tegelijk.",
    myFeedInfoDesc2: "Het heeft ook een abonneerfunctie die automatisch alle nieuwe vermeldingen in deze feedgroep voorstelt aan de feedverbindingen.",
    myConnFilter: "Mijn verbindingenfilter",
    favourites: "FAVORIETEN",
    areYouSure: "Weet je het zeker?",
    sendFeedRequest: "Feedverzoek verzenden",
    projectsPool: "Projectenpool",
    searchByDeveloperName: "Zoek op naam van de ontwikkelaar",
    noListing: "Geen vermelding",
    singleListing: "Lijst",
    multipleListing: "Advertenties",
    projectDetails: "Project details",
    searchByUnit: "Zoek op eenheidsnummer",
    commissionDetails: "Commissiegegevens",
    groupName: "Groepsnaam",
    enterSellingPrice: "Voer de verkoopprijs in",
    commissionCalculator: "Commissiecalculator",
    calculate: "Berekenen",
    result: "Resultaat",
    noofmembers: "Aantal leden",
    filter: "Filter",
    feedOptions: "Feed Opties",
    contract: "Contract",
    addFilter: "Filtre toevoegen",
    deleteFilter: "Filtre verwijderen",
    doYouWantToDeleteThisFilter: "Wilt u dit filtre verwijderen?",
    edit: "Bewerken",
    delete: "Verwijderen",
    editMemberFilter: "Lid filter bewerken",
    createMemberFilter: "Lid filter maken",
    filterID: "Filter ID",
    selected: "Geselecteerd",
    youCanSelectMultiple: "U kunt meerdere selecteren",
    save: "Opslaan",
    cancel: "Annuleren",
    noRequestFound: "Geen aanvraag gevonden",
    sendRequest: "Verzoek verzenden",
    noBlockedMembersMatchYourSearch: "Geen geblokkeerde leden die overeenkomen met uw zoekopdracht.",
    nooflistings: "Aantal vermeldingen",
    inactiveListings: "Inactieve inkopen",
    activeListings: "Actieve inkopen",
    addListings: "Voeg listings toe",
    termsAndConditions: "Voorwaarden",
    backToMyListings: "Terug naar mijn lijsten",
    loading: "Laden...",
    noListingsMatchYourSearch: "Geen inkopen die overeenkomen met uw zoekopdracht.",
    noListingsFound: "Geen inkopen gevonden.",
    contractDetails: "Mijn samenwerkingsvoorwaarden",
    pleaseWaitWhileWeFetchThePropertyDetails: "Please wait while we fetch the property details.",
    view360: "360 view",
    shareOrGroup: "Share or group",
    folder: "Folder",
    gallery: "Gallery",
    removeFeedRequest: "Remove Feed Request",
    viewGallery: "View gallery",
    noOfPortfolio: "No. of portfolio",
    noListingsMatchYourSearch: "Nenhuma listagem corresponde à sua pesquisa.",
    noListingsFound: "Nenhuma listagem encontrada.",
    favorite: "Favorito",
    filterName: "Nome do filtro",
    minPrice: "Preço mínimo",
    maxPrice: "Preço máximo",
    propertyType: "Tipo de propriedade",
    bedroom: "Quarto",
    bathroom: "Banheiro",
    noNewListingsInTheLast24Hours: "Geen nieuwe vermeldingen in de afgelopen 24 uur!",
    noPriceChangesInTheLast24Hours: "Geen prijswijzigingen in de afgelopen 24 uur!",
    noSoldListingsInTheLast24Hours: "Geen verkochte vermeldingen in de afgelopen 24 uur!",
    changeEmailId: "E-mail wijzigen",
    share: "Delen",
    Website: "Website",
    logOut: "Uitloggen",
    changePassword: "Wachtwoord wijzigen",
    oldPassword: "Oud wachtwoord",
    newPassword: "Nieuw wachtwoord",
    confirmPassword: "Wachtwoord bevestigen",
    oldEmail: "Oud e-mail",
    newEmail: "Nieuw e-mail",
    companyWebsite: "Website van de bedrijf",
    titleFunction: "Titel - Functie",
    gender: "Geslacht",
    licenceNumberCertification: "Licentie nummer - Certificaten",
    contactDetails: "Contactgegevens",
    spokenLanguage: "Gepraat taal",
    phoneNo: "Telefoonnummer",
    emailId: "E-mailadres",
    shortIntroduction: "Korte introductie",
    aboutMe: "Over mij",
    companyName: "Bedrijfsnaam",
    yearCreated: "Jaar gemaakt",
    agentCode: "Agentcode",
    country: "Land",
    state: "Provincie",
    city: "Stad",
    zipCode: "Postcode",
    street: "Straat",
    fromDefaultTheme: "Van standaardthema",
    uploadYourImage: "Upload uw afbeelding",
    weblink: "Weblink",
    decline: "Refuser",
    areYouSureYouWantToCancelTheFeedRequest: "Are you sure you want to cancel the feed request?",
    cancelRequest: "Cancel request",
    viewMyShared: "Visualizar meu compartilhado",
    confirmation: "Confirmação",
    yes: "Sim",
    no: "Não",
    connectionFeedSettings: "Configurações de feed de conexão",
    total: "Total",
    shared: "Compartilhado",
    accepted: "Aceito",
    subscribed: "Inscrito",
    areYouSureYouWantToShareYourFeed: "Tem certeza de que deseja compartilhar seu feed?",
    checkingLink: "Verificando link...",
    noLinkAvailable: "Nenhum link disponível",
    folder: "Pasta",
    public: "Público",
    private: "Privado",
    edit: "Editar",
    cancel: "Cancelar",
    save: "Salvar",
    openLink: "Abrir link",
    add: "Adicionar",
    connected: "Conectado",
    premiumMembers: "Membros Premium",
    consumerAppsActive: "Actieve consumentenapps",
    consumerAppSettings: "Instellingen consumentenapp",
    infoRequests: "Solicitações de Informação",
    agentSettings: "Configurações do Agente",
    noAgentsInThisFeed: "Nenhum agente neste feed.",
    list: "Listar",
    completedList: "Lista Completa",
    requestDate: "Data da solicitação",
    hasAListingWith: "tem uma lista com",
    hasAListing: "tem uma lista",
    filterMatchWith: "Filtrar correspondência com:",
    showListing: "Mostrar listagem",
  },



  "pt": {
    // Member Edit screen (info_details.js)
    listings: "Listagens",
    connections: "Conexões",
    portfolio: "Portfólio",
    uploadNewProfilePicture: "Carregar uma nova foto de perfil",
    uploadNewCompanyPicture: "Carregar o logotipo da nova empresa",
    personalInformation: "Informações pessoais",
    companyInformation: "Informações da Empresa",
    male: "Homem",
    female: "Mulher",
    other: "Outro",
    fName: "Primeiro nome",
    lName: "Sobrenome",
    familyName: "Nome de família",
    country: "País",
    state: "Estado",
    city: "Cidade",
    zipCode: "Código Postal",
    street: "Rua",
    number: "Número",
    contactInformation: "Informações de contato",
    email: "E-mail",
    cellPhone: "Telemóvel",
    shortIntro: "Curta introdução ",
    language: "Linguagem",
    chooseLanguage: "Escolha o seu idioma",
    changeEmail: "Mude o e-mail",
    changePassword: "Alterar a senha",
    closeEditMode: "Feche o modo de edição",
    logout: "Sair?",
    hey: "Oi",
    doYouWantToSaveYourInformation: "Salvar mudanças?",   //given as 'Save Changes?'
    companyName: "Nome da empresa",
    title: "Título - Função *",
    licence: "Número da licença - Certificações (s)",
    spokenLanguage: "Línguas falada(s)",
    home: "Início",
    news: "Notícias",
    feed: "Feed",
    listingLayout: "Layout de listagem",
    profile: "Perfil",
    agentCode: "Código do agente",
    appointmentLink: "Link do calendário (opcional)",
    whoami: "Sobre *",
    //home.js
    members: "MEMBROS",
    portfolio: "Portfólio",
    // Information Pop up
    contactUs: "Contate-nos",
    cancel: "Cancelar",
    ok: "OK",
    yes: "Sim",
    no: "Não",
    sendEmail: "Enviar email",
    // members.js
    myconnection: "Minhas conexões",
    connectionrequest: "SOLICITAÇÕES DE",
    memberspool: "MEMBROS",

    // Connection requests
    requestReceived: "Pedidos recebidos",
    requestSent: "Pedidos enviados",
    //portfolio.js
    portfoliofeeds: "Feeds de portfólio",
    portfolionews: "24H Notícias do portfólio",
    listings_portfolio: "Listagens - Portfólio",
    //portfolio_feed.js
    receivedactivefeeds: "Feeds recebidos",
    availablelistings: "Novas angariiações",
    sharedactivefeeds: "Feeds enviados",
    //listing_portfolio.js
    mylistings: "Minhas angariações",
    myportfolio: "Meu Portefeuille",
    portfoliopool: "Portfólio",
    // Portfolio Pool Filters
    filterName: "Nome do filtro",
    inactive: "Inativo",
    public: "Público",
    pocket: "Bolso",
    //-----------------------------------------------------------------

    // //login1.js
    welcome: "Bem-vindo",
    login: "Conecte-se",
    signup: "Inscrever-se",
    descLine1: "Esta aplicação irá ligá-lo a outro agente",
    descLine2: "profissional e ajudá -lo a criar o seu próprio",
    descLine3: "Sistema de listagem múltipla",
    //welcomeBack.js
    welcomeback: "Bem vindo de volta!",
    enteremail: "Digite email",
    enterpassword: "Digite a senha",
    forgotpassword: "Esqueceu sua senha",
    orviasocialmedia: "Ou via média social",
    donthaveanaccount: "Não tem uma conta?",
    // signUpAplication.js
    application: "Aplicação",
    fillInTheDetails: "Preencha os detalhes e crie sua conta",
    company: "Empresa",
    linkedIn: "LinkedIn",
    toKeepTheYesmlsPlatform: "Para manter a plataforma YESMLS exclusivamente para profissionais imobiliários, verificaremos suas informações de inscrição. Após a aprovação do seu aplicativo, terá acesso.",
    next: "PRÓXIMO",

    //New Listing Input
    newListingInput: "Nova entrada de listagem",
    editListingInput: "Editar entrada de listagem",
    listingType: "Tipo de listagem",
    portfolioFeedGroup: "Grupo de feeds de portfólio",
    Pictures: "Fotos",
    addImage: "Adicionar imagem",
    listingInfo: "Informações da angariação",
    plzAddImage: "Por favor, adicione pelo menos uma imagem",

    //Listing Layout
    listingLayout: "Layout da listagem",
    consumerListingLayout: "Consumidor - Layout de listagem",
    activeFields: "Campos ativos",
    inactiveFields: "Campos inativos",
    search: "Pesquisa rápida",
    show: "Mostrar",
    hide: "Esconder",
    position: "Posição",

    //Portfolio News
    all: "Todos",
    new: "Novo",
    priceChange: "Mudança de preço",
    sold: "Vendido",

    //My Feeds
    myFeeds: "Meus feeds",
    viewF1: "Feed 1",
    viewF2: "Feed 2",
    viewF3: "Feed 3",
    viewF4: "Feed 4",
    viewFP: "Valor de entrada",

    //My Profile
    memberSince: "Membro desde ",
    feedShared: "Feed compartilhado",
    feedReceived: "Feed recebido",
    listing: "Listagem",
    connections: "Conexões",
    portfolio: "Portfólio",

    //My Profile
    memberSince: "Membro desde ",
    feedShared: "Feed compartilhado",
    feedReceived: "Alimentação recebida",
    listing: "Listagem",
    connections: "Conexões",
    portfolio: "Portfólio",
    memberBlocked: "Membro bloqueado",
    blockMember: "Bloquear membro",
    unblockMember: "Desbloquear membro",
    //home page 100%
    consumerAppsActive: "APP DE CONSUMO ATIVOS",
    consumerAppFeeds: "Feeds de APPs de consumidores",
    infoRequest: "Solicitações de informações",
    //apps Active
    appsActive: "App ativos",
    lastAppUse: "Último uso do aplicativo",

    //FILTER APPLIED
    filterApplied: "Filtro aplicado",
    country: "País",
    state: "Estado",
    city: "Cidade",
    propertyType: "Tipo de Propriedade",
    priceRange: "Faixa de preço",
    rooms: "quartos",
    bathrooms: "Banheiros",

    //consumer app settings
    consumerAppSettings: "CONFIG. DE APP DE CONSUMO",
    myfeed: "Meu feed",
    multiFeed: "Multi Feed",
    myFeedActive: "Meus feeds de listagens ativos",
    multiFeedActive: "Meu feed de portfólio ativo",
    admin: "Admin",
    default: "Padrão",
    settings: "Configurações",
    pic: "Foto",
    logo: "Logotipo",
    phone: "Telefone",
    email: "Email",
    leads: "Pistas",
    chooseAgent: "Escolha agente",
    consumerChooseAgent: "O consumidor escolhe agente",
    //info requests
    infoRequest: "SOLICITAÇÖES DE INFO",
    active: "Ativo",
    completed: "Concluído",
    //MEMBERS FEED ACTIVE
    memberFeedActive: "Feed de membros ativos",
    feedActive: "Feed ativo",
    viewFeed: "Ver Feed",
    deleteFeed: "Excluir feed",
    //MEMBER FEED REQUEST SENT
    feedRequested: "Feed solicitado",
    memberFeedRequestSent: "Solicitação de feed de membro enviado",
    feedRequestSent: "Solicitação de feed enviado",
    viewFeedRequest: "Ver solicitação de feed",
    cancelFeedRequest: "Cancelar a solicitação de alimentação",
    //MY FEED SHARED
    myFeedShared: "Meu feed compartilhado",
    generalFeed: "Feed geral",
    individualFeed: "Feed individual",
    //MY FEED PROPOSED
    myFeedProposed: "Meu feed proposto",
    feesSent: "Feed enviado",
    changeFeed: "Alterar Feed",
    //NEW LISTING RECEIVED
    newListingReceive: "Nova listagem recebida",
    //INCOMING MEMBER FEED
    incomingMemberFeed: "Feed de membros recebidos",
    totalPublished: "Total publicado",
    totalAccepted: "Total aceite",
    totalShared: "Total compartilhado",
    accepted: "Aceitaram",
    published: "Publicados",
    unpublished: "Não publicados",
    //other pages
    memberFilter: "Filtro de membro",
    plzSelctCountry: "Selecione um país primeiro",
    plzSelctState: "Selecione um estado primeiro",
    blockedMembers: "Membros bloqueados",
    filterActive: "Filtro ativo",
    sponsorArea: "Patrocinador na \n area",
    memberFeedFilter: "Filtro de alimentação de membros",
    scanCode: "Código de digitalização",
    //CONNECTION FEED SETTINGS
    connectionFeedSettings: "Feed de configurações de conexão",
    notShared: "Não compartilhado",
    total: "Total",
    shared: "Compartilhado",
    accept: "Aceite",
    subscribed: "Subscrito",
    feed: "Feed",
    //PUSH NOTIFICATION
    pushNotification: "NOTIFICAÇÕES VIA PUSH",
    connectionRequest: "Solicitações de conexão",
    newConnection: "Nova ligação",
    feedRequestReceived: "Solicitação de alimentação recebida",
    feedSharedAccepted: "Feed compartilhado aceite",
    newAvailableListing: "Nova listagem disponível",
    myPortfolioPriceChange: "Minha mudança de preço do portfólio",
    myPortfolioSold: "Meu portfólio foi vendido",
    myPortfolioComingSoon: "Meu portfólio em breve",
    // /PORTFOLIO FILTER
    portfolioFilter: "Filtro de portfólio",
    enterFilterName: "Digite o nome do filtro",
    price: "Preço",
    min: "Min",
    max: "Máx",
    bedrooms: "Quartos de dormir",
    //PORTFOLIO POOL FAVOURITE
    portfolioPoolFav: "Favoritos da carteira",
    //ALERT DIALOG
    errorMsg: "Erro, por favor verifique",
    requestFrom: "Solicitação de ",
    declineCRequest: "Recusar a solicitação de conexão?",
    requestTo: "Solicitação para ",
    cancelCRequest: "Cancelar a solicitação de conexão?",
    confirmationMsg: "Confirmação",
    shareFeedMsg: "Tem certeza de que deseja compartilhar seu feed?",
    enterAllField: "Por favor, insira toda a informação necessária!",
    logout: "Sair",
    logoutMsg: "Tem certeza que deseja sair ?",
    subscriptionMsg: "Obter informações sobre o Premium?",
    checkOutMsg: "Por favor verifique ",
    deleteFilterMsg: "Tem certeza de que deseja excluir este filtro?",
    feedFrom: "Alimentação de ",
    deleteFeedRequest: "Deseja excluir a solicitação de feed?",
    declineFeedRequest: "Deseja recusar um pedido do seu feed?",
    removedSucessfully: "Removido com sucesso",
    invalidInput: "entrada inválida",
    noLinkAvailable: "Nenhum link disponível",
    removeListing: "Remova a listagem",
    wantToRemoveListing: "Tem certeza de que deseja remover a listagem?",
    plzAddProfileImage: "Adicione a imagem do perfil",
    plzAddCompanyLogo: "Adicione o logotipo da empresa",
    plzAddCName: "Adicione o nome da empresa",
    plzAddTitle: "Adicione o título - função",
    plzAddFName: "Adicione o primeiro nome",
    plzAddFamilyName: "Por favor, adicione o nome de família",
    plzAddCountry: "Por favor, adicione o país",
    plzAddState: "Por favor, adicione estado",
    plzAddCity: "Por favor, adicione a cidade",
    plzAddZip: "Adicione o código postal",
    plzAddStreet: "Por favor, adicione a rua",
    plzAddNumber: "Por favor, adicione o número",
    plzAddEmail: "Adicione o endereço de e-mail",
    plzAddCell: "Por favor adicione o número do celular",
    plzAddIntro: "Por favor, adicione uma introdução curta",
    plzAddWMI: "Por favor, adicione 'quem sou eu'",
    plzAddLinkedin: "Adicione seu LinkedIn / site",
    notValidLinkedIn: "Não é um endereço do LinkedIn válido",
    notValidAppoLink: "Não é um link de calendly válido",
    canNotEditEmail: "não pode editar endereço de e-mail",
    plzEnterRequiredField: "Por favor, digite todos os campos necessários!",
    maxPictureUploaded: "Upload de imagens máximo alcançado",
    unpublishFirst: "Por favor, cancele a publicação primeiro",
    acceptFeedFirst: "Por favor, aceite o feed primeiro",
    chooseOption: "Escolha a opção",
    sendMyFeed: "Envie meu feed",
    requestFeed: "Solicitar feed",
    blockThisMember: "Bloquear este membro?",
    unBlockThisMember: "Desbloquear este membro?",
    removeConnection: "Remover conexão?",

    plzCompleteProfile: "Preencha os detalhes do seu perfil",

    // NOTIFICATIONS
    notifications: "Notificações",

    atleastOneAgent: 'Você deve escolher pelo menos um agente',
    websiteSettings: 'Configurações do site',
    viewDetails: 'Ver detalhes',
    My: 'Meu',
    globalPortfolio: 'Portfólio Global',
    globalMembers: 'Membros globais',
    inactiveListings: 'Listagens inativas',
    noNewListing24: 'Não há novas angariações nas últimas 24 horas!',
    noPriceChange24: 'Nenhuma alteração de preço nas últimas 24 horas!',
    noSold24: 'Nenhuma angariação vendida nas últimas 24 horas!',
    abountMe: 'Sobre mim',
    noAbout: "O utilizador ainda não adicionou essas informações!",
    searchByStreet: 'Pesquise por rua',
    searchByName: 'Procura por nome',
    searchByStreetAgent: 'Pesquise por rua / agente',
    noConnAvailable: "Sem conexões disponíveis",
    newAvailable: 'Novo disponível',
    createPortfolioFilter: 'Criar filtro',
    editPortfolioFilter: 'Editar filtro',
    feedsReceived: 'Feeds recebidos',
    feedsRequested: 'Feeds solicitados',
    myActiveFeeds: 'Meus feeds ativos',
    webSettings: "Configurações da Web",
    currentBannerImage: "Imagem do banner atual",
    changeBannerImage: "Alterar a imagem do banner",
    fromDefaultTheme: "Do tema padrão",
    uploadYourImage: "Envie a sua imagem",
    bannerHeading: "Título de banner",
    bannerSubHeading: "Banner Sub-título",
    cardHeading: "Cabeçalho do cartão",
    cardDescription: "Descrição do cartão",
    siteTitle: "titulo do site",
    siteDescription: "Descrição do Site",
    siteFavIcon: "Ícone favorito do site",
    defaultLang: "Idioma padrão",
    update: "Atualizar",
    listingMatch: "listagem Match",
    clientMatch: "Correspondência de Clientes",
    showListing: "Mostrar angariação",
    filterMatchWith: "Filtro combinando com:",
    feedRequestSettings: "Configurações de solicitação de feed",
    info: "Informação",
    feedProposed: 'Feed proposto',
    acceptFeed: "Aceitar feed",
    declineFeed: "Recusar feed",
    contractDetails: "Meus termos e condições de cooperação",
    updatedSuccessfully: "Atualizado com sucesso",
    searchByNameAndCompany: 'Pesquise por nome / empresa',
    listingInfoRequest: "Listando a solicitação de informações",
    myProfile: "Meu perfil",
    saveChanges: "Quer salvar as alterações?",
    submit: "Enviar",
    listingsInFeed: "Listagens em feeds",
    agentCode: "Código do agente",
    premiumAgent: "Agente Premium",
    mySocialChannels: "Meus canais sociais",
    yearCreated: "Ano criado",
    shareAndAcceptedBy: "Compartilhado e aceite por",
    listingRequestSent: 'Solicitação de listagem enviada',
    cancelListingRequest: "Cancelar a solicitação de listagem",
    Projects: "Projetos",
    enterContractDetails: "Insira os detalhes do contrato",
    noBlockedMembers: "Nenhum membro bloqueado",
    noFeedSentYet: "Nenhum feed enviado ainda",
    sendConnectionRequest: "Enviar solicitação de conexão?",
    selectPhoto: "Selecione a foto",
    noneString: "Nenhum",
    deleteFeedMsg: "Deseja excluir este feed?",
    feedShareWith: "Feed compartilhado com ",
    myFeedInfoDesc1: "Os feeds são uma coleção de listagens que podem ser compartilhadas com suas conexões com um clique. Isso economiza tempo e esforço em comparação ao compartilhamento de uma listagem por vez.",
    myFeedInfoDesc2: "Ele também possui um recurso de inscrição que sugere automaticamente todas as novas listagens inseridas neste grupo de feeds para as conexões de feed.",
    myConnFilter: "Filtro Minhas Conexões",
    favourites: "FAVORITOS",
    areYouSure: "Tem certeza?",
    sendFeedRequest: "Feedverzoek verzenden",
    projectsPool: "Conjunto de projetos",
    searchByDeveloperName: "Pesquisar por nome do desenvolvedor",
    noListing: "Nenhuma listagem",
    singleListing: "Listagem",
    multipleListing: "Listagens",
    projectDetails: "Detalhes do Projeto",
    searchByUnit: "Pesquisar por número de unidade",
    commissionDetails: "Detalhes da Comissão",
    groupName: "Nome do grupo",
    enterSellingPrice: "Insira o preço de venda",
    commissionCalculator: "Calculadora de Comissão",
    calculate: "Calcular",
    result: "Resultado",
    noofmembers: "Número de membros",
    filter: "filtro",
    feedOptions: "Opções de Feed",
    contract: "Contrato",
    addFilter: "Filtro adicionar",
    deleteFilter: "Filtro deletar",
    doYouWantToDeleteThisFilter: "Você quer deletar este filtro?",
    edit: "Editar",
    delete: "Deletar",
    editMemberFilter: "Editar filtro",
    createMemberFilter: "Criar filtro",
    filterID: "ID do filtro",
    selected: "Selecionado",
    youCanSelectMultiple: "Você pode selecionar vários",
    save: "Salvar",
    cancel: "Cancelar",
    noRequestFound: "Nenhuma solicitação encontrada",
    sendRequest: "Enviar solicitação",
    noBlockedMembersMatchYourSearch: "Nenhum membro bloqueado corresponde à sua pesquisa.",
    nooflistings: "Número de listagens",
    inactiveListings: "Listagens inativas",
    activeListings: "Listagens ativas",
    addListings: "Adicionar listagens",
    termsAndConditions: "Termos e condições",
    backToMyListings: "Voltar para minhas listagens",
    loading: "Carregando...",
    noListingsMatchYourSearch: "Nenhuma listagem corresponde à sua pesquisa.",
    noListingsFound: "Nenhuma listagem encontrada.",
    contractDetails: "Meus termos e condições de cooperação",
    pleaseWaitWhileWeFetchThePropertyDetails: "Por favor, aguarde enquanto buscamos os detalhes da propriedade.",
    view360: "Visualização 360",
    shareOrGroup: "Compartilhar ou agrupar",
    folder: "Pasta",
    gallery: "Galeria",
    removeFeedRequest: "Remover solicitação de feed",
    viewGallery: "Visualizar galeria",
    noOfPortfolio: "Número de portfólio",
    noListingsMatchYourSearch: "Nenhuma listagem corresponde à sua pesquisa.",
    noListingsFound: "Nenhuma listagem encontrada.",
    favorite: "Favorito",
    filterName: "Nome do filtro",
    minPrice: "Preço mínimo",
    maxPrice: "Preço máximo",
    propertyType: "Tipo de propriedade",
    bedroom: "Quarto",
    bathroom: "Banheiro",
    noNewListingsInTheLast24Hours: "Sem novos anúncios nas últimas 24 horas!",
    noPriceChangesInTheLast24Hours: "Sem alterações de preço nas últimas 24 horas!",
    noSoldListingsInTheLast24Hours: "Nenhum imóvel foi vendido nas últimas 24 horas!",
    changeEmailId: "Mudar e-mail",
    share: "Compartilhar",
    Website: "Website",
    logOut: "Sair",
    changePassword: "Mudar senha",
    oldPassword: "Senha antiga",
    newPassword: "Nova senha",
    confirmPassword: "Confirmar senha",
    oldEmail: "E-mail antigo",
    newEmail: "E-mail novo",
    companyWebsite: "Website da empresa",
    titleFunction: "Título - Função",
    gender: "Gênero",
    licenceNumberCertification: "Número da licença - Certificações",
    contactDetails: "Detalhes de contato",
    spokenLanguage: "Línguas falada(s)",
    phoneNo: "Telefone",
    emailId: "E-mail",
    shortIntroduction: "Introdução curta",
    aboutMe: "Sobre mim",
    companyName: "Nome da empresa",
    yearCreated: "Ano criado",
    agentCode: "Código do agente",
    country: "País",
    state: "Estado",
    city: "Cidade",
    zipCode: "Código postal",
    street: "Rua",
    fromDefaultTheme: "Do tema padrão",
    uploadYourImage: "Envie a sua imagem",
    webSettings: "Configurações da Web",
    currentBannerImage: "Imagem do banner atual",
    changeBannerImage: "Alterar a imagem do banner",
    fromDefaultTheme: "Do tema padrão",
    uploadYourImage: "Envie a sua imagem",
    bannerHeading: "Título do banner",
    bannerSubHeading: "Sub-título do banner",
    cardHeading: "Título do card",
    cardDescription: "Descrição do card",
    weblink: "link da web",
    decline: "Recusar",
    areYouSureYouWantToDelete: "Tem certeza de que deseja excluir?",
    areYouSureYouWantToDecline: "Tem certeza de que deseja recusar?",
    areYouSureYouWantToCancelTheFeedRequest: "Tem certeza de que deseja cancelar a solicitação de feed?",
    cancelRequest: "Cancelar solicitação",
    viewMyShared: "Visualizar meu compartilhado",
    connectionFeedSettings: "Configurações de feed de conexão",
    confirmation: "Confirmação",
    yes: "Sim",
    no: "Não",
    connectionFeedSettings: "Configurações de feed de conexão",
    total: "Total",
    shared: "Compartilhado",
    accepted: "Aceito",
    subscribed: "Inscrito",
    areYouSureYouWantToShareYourFeed: "Tem certeza de que deseja compartilhar seu feed?",
    checkingLink: "Verificando link...",
    noLinkAvailable: "Nenhum link disponível",
    folder: "Pasta",
    public: "Público",
    private: "Privado",
    edit: "Editar",
    cancel: "Cancelar",
    save: "Salvar",
    cancel: "Cancelar",
    openLink: "Abrir link",
    add: "Adicionar",
    connected: "Conectado",
    premiumMembers: "Membros Premium",
    consumerAppsActive: "Aplicativos de Consumidor Ativos",
    consumerAppSettings: "Configurações de Aplicativo de Consumidor",
    infoRequests: "Solicitações de Informação",
    agentSettings: "Configurações do Agente",
    noAgentsInThisFeed: "Nenhum agente neste feed.",
    list: "Listar",
    completedList: "Lista Completa",
    requestDate: "Data da solicitação",
    hasAListingWith: "tem uma lista com",
    hasAListing: "tem uma lista",
    filterMatchWith: "Filtrar correspondência com:",
    showListing: "Mostrar listagem",
  },





};

const stringsoflanguages = createWebLocalizedStrings(translations, 'en');

export default stringsoflanguages;